/**
 * This class is auto generated by using the
 * "Dots.KLASIS.TsGenerator".
 * */
export const routes = {

    title: {
        classifications: `Klasifikācijas`,
        easyToRead: `Viegli lasīt`,
        home: `Sākums`,
        lodResources: `Linked Open Data Pamatresursu saraksts`,
        searchResults: `Meklēšanas rezultāti`,
    },
}
